module.exports = __webpack_public_path__ + "videos/ca77e50a6b8c9c8a2d5e453a0a1828bd.mp4";